import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import socialLinks from './socialLinks';
import "../css/styles.css";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="page">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Manvidia — Innovation Matters" />
            <p>AI agents, websites and software products built for growing businesses.</p>
            <div className="social-links">
              {socialLinks.map(({ label, href, Icon }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4>Company</h4>
            <ul className="footer-links">
              <li><Link to="/about-us">Who we are</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/opportunities">Opportunities</Link></li>
              <li><Link to="/contact-us">Contact us</Link></li>
            </ul>
          </div>

          <div>
            <h4>Products</h4>
            <ul className="footer-links">
              <li><HashLink smooth to="/products#commentIQ">Comment IQ</HashLink></li>
              <li><HashLink smooth to="/products#reconIQ">ReconIQ</HashLink></li>
            </ul>
          </div>

          <div>
            <h4>Get in touch</h4>
            <ul className="footer-links">
              <li><a href="mailto:info@manvidia.com">info@manvidia.com</a></li>
              <li><a href="tel:+918860018741">+91-8860018741</a></li>
              <li>Supertech Capetown, NOIDA 201301</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} MANVIDIA AI Solutions. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
